export default {
  setMerchant(state, data) {
    state.user.loggedRole.merchant = data
  },
  setPayments(state, data) {
    state.payments = data
  },
  changeCredits(state, data) {
    state.user.loggedRole.merchant.credits += data
  },
  setPaymentsMethods(state, data) {
    state.user.loggedRole.merchant.donation = {
      ...state.user.loggedRole.merchant.donation,
      stripe: data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/merchants.js